import { render, staticRenderFns } from "./AddPackingDirectLinklBranch.vue?vue&type=template&id=34fc792f"
import script from "./AddPackingDirectLinklBranch.vue?vue&type=script&lang=js"
export * from "./AddPackingDirectLinklBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports